const PING = 'PING';
const PONG = 'PONG';

export { PING, PONG };
